(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mobx"), require("mobxReact"), require("React"), require("ReactRouter"), require("ReactDOM"), require("weaIntegrationEngine"));
	else if(typeof define === 'function' && define.amd)
		define(["mobx", "mobxReact", "React", "ReactRouter", "ReactDOM", "weaIntegrationEngine"], factory);
	else if(typeof exports === 'object')
		exports["weaIntegrationEngine"] = factory(require("mobx"), require("mobxReact"), require("React"), require("ReactRouter"), require("ReactDOM"), require("weaIntegrationEngine"));
	else
		root["weaIntegrationEngine"] = factory(root["mobx"], root["mobxReact"], root["React"], root["ReactRouter"], root["ReactDOM"], root["weaIntegrationEngine"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__, __WEBPACK_EXTERNAL_MODULE_144__, __WEBPACK_EXTERNAL_MODULE_569__, __WEBPACK_EXTERNAL_MODULE_583__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition